export const TimelineSvg = (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.34896 8.66667C6.61563 8.66667 6.01562 8.06667 6.01562 7.33333C6.01562 6.6 6.60229 6 7.34896 6H7.36229C8.09562 6 8.69562 6.6 8.69562 7.33333C8.69562 8.06667 8.09563 8.66667 7.34896 8.66667Z'
      fill='#A1A1AA'
    />
    <path
      d='M24.681 25.9999C23.9477 25.9999 23.3477 25.3999 23.3477 24.6666C23.3477 23.9333 23.9343 23.3333 24.681 23.3333H24.6943C25.4277 23.3333 26.0277 23.9333 26.0277 24.6666C26.0277 25.3999 25.4277 25.9999 24.681 25.9999Z'
      fill='#A1A1AA'
    />
    <path
      d='M7.29167 13.0001C4.17167 13.0001 1.625 10.4534 1.625 7.33341C1.625 4.21341 4.17167 1.66675 7.29167 1.66675C10.4117 1.66675 12.9583 4.21341 12.9583 7.33341C12.9583 10.4534 10.425 13.0001 7.29167 13.0001ZM7.29167 3.66675C5.265 3.66675 3.625 5.30675 3.625 7.33341C3.625 9.36008 5.265 11.0001 7.29167 11.0001C9.31833 11.0001 10.9583 9.36008 10.9583 7.33341C10.9583 5.30675 9.31833 3.66675 7.29167 3.66675Z'
      fill='#A1A1AA'
    />
    <path
      d='M26.6237 30.3333H22.6237C20.597 30.3333 18.957 28.6933 18.957 26.6667V22.6667C18.957 20.64 20.597 19 22.6237 19H26.6237C28.6504 19 30.2904 20.64 30.2904 22.6667V26.6667C30.2904 28.6933 28.6504 30.3333 26.6237 30.3333ZM22.6237 21C21.7037 21 20.957 21.7467 20.957 22.6667V26.6667C20.957 27.5867 21.7037 28.3333 22.6237 28.3333H26.6237C27.5437 28.3333 28.2904 27.5867 28.2904 26.6667V22.6667C28.2904 21.7467 27.5437 21 26.6237 21H22.6237Z'
      fill='#A1A1AA'
    />
    <path
      d='M16.0032 26.3334H12.4298C10.8832 26.3334 9.53651 25.4001 9.00318 23.9601C8.45651 22.5201 8.85651 20.9334 10.0165 19.9067L20.6698 10.5867C21.3098 10.0267 21.3232 9.26675 21.1365 8.74675C20.9365 8.22675 20.4298 7.66675 19.5765 7.66675H16.0032C15.4565 7.66675 15.0032 7.21341 15.0032 6.66675C15.0032 6.12008 15.4565 5.66675 16.0032 5.66675H19.5765C21.1232 5.66675 22.4698 6.60008 23.0032 8.04008C23.5498 9.48008 23.1498 11.0667 21.9898 12.0934L11.3365 21.4134C10.6965 21.9734 10.6832 22.7334 10.8698 23.2534C11.0698 23.7734 11.5765 24.3334 12.4298 24.3334H16.0032C16.5498 24.3334 17.0032 24.7867 17.0032 25.3334C17.0032 25.8801 16.5498 26.3334 16.0032 26.3334Z'
      fill='#A1A1AA'
    />
  </svg>
);

export const EditorSvg = (
  <svg
    width='32'
    height='32'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.2393 15.1667H3.72593C2.71259 15.1667 1.78593 14.6534 1.25259 13.7867C0.71926 12.92 0.672593 11.8667 1.12593 10.9534L2.27259 8.65337C2.64593 7.9067 3.24593 7.44003 3.91926 7.3667C4.59259 7.29337 5.27926 7.6267 5.79926 8.27337L5.94593 8.46003C6.23926 8.82003 6.57926 9.01337 6.91259 8.98003C7.24593 8.95337 7.55259 8.71337 7.77926 8.3067L9.03926 6.03337C9.55926 5.09337 10.2526 4.6067 11.0059 4.64003C11.7526 4.68003 12.3926 5.24003 12.8193 6.2267L14.9059 11.1C15.2926 12 15.1993 13.0267 14.6593 13.8467C14.1259 14.68 13.2193 15.1667 12.2393 15.1667ZM4.10593 8.3667C4.07926 8.3667 4.05259 8.3667 4.02593 8.37337C3.69259 8.4067 3.38593 8.67337 3.16593 9.1067L2.01926 11.4067C1.71926 12 1.75259 12.7 2.09926 13.2667C2.44593 13.8334 3.05926 14.1734 3.72593 14.1734H12.2326C12.8859 14.1734 13.4659 13.86 13.8259 13.3134C14.1859 12.7667 14.2459 12.1134 13.9859 11.5134L11.8993 6.64003C11.6459 6.04003 11.2926 5.67337 10.9526 5.66003C10.6393 5.64003 10.2326 5.97337 9.91259 6.54003L8.65259 8.81337C8.26593 9.5067 7.65926 9.94003 6.99926 10C6.33926 10.0534 5.66593 9.73337 5.16593 9.1067L5.01926 8.92003C4.73926 8.55337 4.41926 8.3667 4.10593 8.3667Z'
      fill='#A1A1AA'
    />
    <path
      d='M4.64844 5.8335C3.2751 5.8335 2.14844 4.7135 2.14844 3.3335C2.14844 1.9535 3.26844 0.833496 4.64844 0.833496C6.02844 0.833496 7.14844 1.9535 7.14844 3.3335C7.14844 4.7135 6.02844 5.8335 4.64844 5.8335ZM4.64844 1.8335C3.82177 1.8335 3.14844 2.50683 3.14844 3.3335C3.14844 4.16016 3.82177 4.8335 4.64844 4.8335C5.4751 4.8335 6.14844 4.16016 6.14844 3.3335C6.14844 2.50683 5.4751 1.8335 4.64844 1.8335Z'
      fill='#A1A1AA'
    />
  </svg>
);

export const DeleteSvg = (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 2V1.5C6 1.22386 6.22386 1 6.5 1H9.5C9.77614 1 10 1.22386 10 1.5V2H13C13.2761 2 13.5 2.22386 13.5 2.5C13.5 2.77614 13.2761 3 13 3H12V13.5C12 14.3284 11.3284 15 10.5 15H5.5C4.67157 15 4 14.3284 4 13.5V3H3C2.72386 3 2.5 2.77614 2.5 2.5C2.5 2.22386 2.72386 2 3 2H6ZM5 3V13.5C5 13.7761 5.22386 14 5.5 14H10.5C10.7761 14 11 13.7761 11 13.5V3H5ZM7 1.5V2H9V1.5H7Z'
      fill='#ff4d4f'
    />
    <path
      d='M6.5 5C6.77614 5 7 5.22386 7 5.5V11.5C7 11.7761 6.77614 12 6.5 12C6.22386 12 6 11.7761 6 11.5V5.5C6 5.22386 6.22386 5 6.5 5Z'
      fill='#ff4d4f'
    />
    <path
      d='M9.5 5C9.77614 5 10 5.22386 10 5.5V11.5C10 11.7761 9.77614 12 9.5 12C9.22386 12 9 11.7761 9 11.5V5.5C9 5.22386 9.22386 5 9.5 5Z'
      fill='#ff4d4f'
    />
  </svg>
);

export const ClearSvg = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M5.37546 7.08348C5.32546 7.08348 5.27547 7.07513 5.22547 7.0668C5.06713 7.02513 4.92546 6.92516 4.84213 6.78349L3.54213 4.65016C3.22546 4.1335 3.12546 3.51682 3.27546 2.91682C3.41712 2.32515 3.7838 1.81681 4.3088 1.50014C4.82546 1.18347 5.44213 1.08347 6.04213 1.23347C6.64213 1.37513 7.14213 1.74179 7.4588 2.26679L8.75879 4.40017C8.94213 4.69184 8.84213 5.07515 8.55046 5.25848L5.70046 6.99183C5.60046 7.05016 5.49213 7.08348 5.37546 7.08348ZM5.49213 2.41684C5.30046 2.41684 5.11713 2.46683 4.9588 2.56683C4.72546 2.7085 4.5588 2.94179 4.49213 3.20846C4.42546 3.48346 4.46713 3.75846 4.6088 3.9918L5.5838 5.59183L7.36713 4.50846L6.39213 2.90847C6.25046 2.67514 6.01713 2.50848 5.75046 2.44181C5.65879 2.42514 5.57546 2.41684 5.49213 2.41684Z'
      fill='#71717A'
    />
    <path
      d='M9.51581 18.8419C9.26581 18.8419 9.01581 18.8085 8.77414 18.7335C8.04081 18.5169 7.44914 18.0169 7.10747 17.3086L5.39914 13.8252C4.49081 11.9752 5.13248 9.77521 6.89081 8.70021L9.52414 7.10023C11.2825 6.02523 13.5408 6.46688 14.7658 8.12521L17.0741 11.2419C17.5408 11.8752 17.7158 12.6335 17.5741 13.3752C17.4325 14.1169 16.9825 14.7586 16.3075 15.1669L10.9491 18.4252C10.4991 18.7002 10.0075 18.8419 9.51581 18.8419ZM11.5825 7.76688C11.0991 7.76688 10.6158 7.9002 10.1658 8.16687L7.53247 9.76685C6.32414 10.5002 5.89081 12.0085 6.50747 13.2752L8.21581 16.7585C8.40748 17.1419 8.72414 17.4169 9.11581 17.5335C9.50748 17.6502 9.92414 17.5836 10.2825 17.3669L15.6408 14.1085C16.0075 13.8835 16.2491 13.5419 16.3325 13.1419C16.4075 12.7419 16.3158 12.3336 16.0575 11.9919L13.7491 8.87523C13.2241 8.15023 12.4158 7.76688 11.5825 7.76688Z'
      fill='#71717A'
    />
    <path
      d='M6.39807 10.3581C6.34807 10.3581 6.29807 10.3498 6.24807 10.3414C6.08974 10.2998 5.94807 10.1998 5.86473 10.0581L4.13141 7.20813C3.94808 6.91647 4.04808 6.53311 4.33974 6.34977L8.60641 3.74978C8.89807 3.57478 9.28974 3.66645 9.46474 3.95811L11.1981 6.8081C11.2814 6.94976 11.3147 7.11644 11.2731 7.2831C11.2314 7.44144 11.1314 7.58312 10.9897 7.66646L6.72308 10.2665C6.62308 10.3331 6.5064 10.3581 6.39807 10.3581ZM5.52308 7.09979L6.6064 8.88309L9.80641 6.93312L8.72307 5.14977L5.52308 7.09979Z'
      fill='#71717A'
    />
    <path
      d='M13.3015 16.8921C13.0931 16.8921 12.8848 16.7837 12.7681 16.592L11.3931 14.3337C11.2098 14.0421 11.3098 13.6587 11.6015 13.4754C11.8931 13.3004 12.2848 13.392 12.4598 13.6837L13.8348 15.942C14.0181 16.2337 13.9181 16.617 13.6265 16.8004C13.5265 16.8587 13.4098 16.8921 13.3015 16.8921Z'
      fill='#71717A'
    />
    <path
      d='M11.1647 18.1919C10.9564 18.1919 10.7481 18.0835 10.6314 17.8918L9.25641 15.6335C9.07308 15.3419 9.17308 14.9585 9.46474 14.7752C9.75641 14.6002 10.1481 14.6918 10.3231 14.9835L11.6981 17.2419C11.8814 17.5335 11.7814 17.9168 11.4897 18.1002C11.3897 18.1585 11.2731 18.1919 11.1647 18.1919Z'
      fill='#71717A'
    />
    <path
      d='M15.4343 15.5913C15.2259 15.5913 15.0176 15.4829 14.9009 15.2912L13.5259 13.0329C13.3426 12.7413 13.4426 12.3579 13.7343 12.1746C14.0259 11.9996 14.4176 12.0913 14.5926 12.3829L15.9676 14.6413C16.1509 14.9329 16.0509 15.3162 15.7593 15.4996C15.6593 15.5579 15.5509 15.5913 15.4343 15.5913Z'
      fill='#71717A'
    />
  </svg>
);
